
const API_URL = 

window.location.hostname === "localhost"
    ? "http://localhost:8081"
    : "https://oret.ke/tree/mobile/backend";


export default API_URL;
